<template>
	<div class="filter-row">
		<span class="filter-text">{{ title }}</span>
		<div class="color-picker-wrapper" v-click-outside="ffefd5">
			<div class="color-raio-btn" :style="radioColors" @click="isVisible = true"></div>
			<colorPicker class="picker" v-if="isVisible" :defaultColor="color" @colorChange="handleColorChange" />
		</div>
	</div>
</template>

<script>
import colorPicker from './colorPicker';

export default {
	name: 'settingRow',
	components: { colorPicker },
	props: {
		id: { required: true, type: String },
		color: { required: true, type: String },
		title: { required: true, type: String },
	},
	data() {
		return {
			currentColor: this.color,
			isVisible: false,
		};
	},
	computed: {
		radioColors() {
			return {
				'--backgroundColor': this.color,
			};
		},
	},
	methods: {
		handleColorChange(colorValue) {
			console.log('handleColorChange', { id: this.id, colorValue });
			this.currentColor = colorValue;
		},
		ffefd5(e) {
			if (!this.isVisible) return;
			this.isVisible = false;
			this.$emit('colorChange', { id: this.id, colorValue: this.currentColor });
		},
	},
};
</script>

<style lang="scss" scoped>
.filter-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 15px;

	.filter-text {
		font-size: 14px;
		color: #76839a;
	}

	.color-picker-wrapper {
		position: relative;

		.color-raio-btn {
			width: 20px;
			height: 20px;
			background: var(--backgroundColor);
			border-radius: 5px;
		}

		.picker {
			position: absolute;
			top: 20px;
		}
	}
	.filter-color {
		width: 24px;
		height: 24px;
		border-radius: 3px;
		background-color: #517fa8;
	}
}
</style>
